import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Card from "components/cards/Card";
import { Grid, Button } from "@material-ui/core";

import { useHistory } from "react-router-dom";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import slider1 from "assets/images/causes_inner/1.jpg";
import slider2 from "assets/images/causes_inner/2.jpg";
import slider3 from "assets/images/causes_inner/3.jpg";
import slider4 from "assets/images/causes_inner/4.jpg";
import slider5 from "assets/images/causes_inner/5.jpg";
import slider6 from "assets/images/causes_inner/6.jpg";
import slider7 from "assets/images/causes_inner/7.jpg";
import slider8 from "assets/images/causes_inner/8.jpg";
import slider9 from "assets/images/causes_inner/9.jpg";
import slider10 from "assets/images/causes_inner/10.jpg";
import slider11 from "assets/images/causes_inner/11.jpg";
import slider12 from "assets/images/causes_inner/12.jpg";
import slider13 from "assets/images/causes_inner/13.jpg";
import slider14 from "assets/images/causes_inner/14.jpg";
import slider15 from "assets/images/causes_inner/15.jpg";
import slider16 from "assets/images/causes_inner/16.jpg";
import hurricaneMainImage from "assets/images/causes_inner/hurricane-ida-relief.png";
import hurricaneSliderImage1 from "assets/images/causes_inner/hurricane-ida-relief-1.png";
import hurricaneSliderImage2 from "assets/images/causes_inner/hurricane-ida-relief-2.png";
import hurricaneSliderImage3 from "assets/images/causes_inner/hurricane-ida-relief-3.png";
import fosterKinshipMainImage from "assets/images/causes/foster_kinship_main.jpg";
import forstKinshipSliderImage1 from "assets/images/causes/foster_kinship_1.jpg";
import forstKinshipSliderImage3 from "assets/images/causes/foster_kinship_3.jpg";
import forstKinshipSliderImage4 from "assets/images/causes/foster_kinship_4.png";
import flagsForFreedomMainImage from "assets/images/causes/flags_freedom1.png";
import flagsForFreedomSliderImage1 from "assets/images/causes/flags_freedom2.png";
import flagsForFreedomSliderImage3 from "assets/images/causes/flags_freedom3.png";
import flagsForFreedomSliderImage4 from "assets/images/causes/flags_freedom4.png";

import slidert from "assets/images/causes/slide-rt.jpg";
import sildele from "assets/images/causes/slide-le.jpg";

import { callGetApiWithAuth } from "utils/api";
import { asPrice } from "utils/text";

export default function Details(props) {
  const classes = useStyles();
  const history = useHistory();
  const [causeData, setCauseData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const feedingImages = [
    {
      original: slider1,
      thumbnail: slider1,
    },
    {
      original: slider16,
      thumbnail: slider16,
    },
    {
      original: slider15,
      thumbnail: slider15,
    },
    {
      original: slider14,
      thumbnail: slider14,
    },
  ];
  const fightingImages = [
    {
      original: slider9,
      thumbnail: slider9,
    },
    {
      original: slider8,
      thumbnail: slider8,
    },
    {
      original: slider7,
      thumbnail: slider7,
    },
    {
      original: slider6,
      thumbnail: slider6,
    },
  ];
  const supportingImages = [
    {
      original: slider13,
      thumbnail: slider13,
    },
    {
      original: slider12,
      thumbnail: slider12,
    },
    {
      original: slider11,
      thumbnail: slider11,
    },
    {
      original: slider10,
      thumbnail: slider10,
    },
  ];
  const environmentImages = [
    {
      original: slider5,
      thumbnail: slider5,
    },
    {
      original: slider4,
      thumbnail: slider4,
    },
    {
      original: slider3,
      thumbnail: slider3,
    },
    {
      original: slider2,
      thumbnail: slider2,
    },
  ];
  const hurricaneImages = [
    {
      original: hurricaneMainImage,
      thumbnail: hurricaneMainImage,
    },
    {
      original: hurricaneSliderImage1,
      thumbnail: hurricaneSliderImage1,
    },
    {
      original: hurricaneSliderImage2,
      thumbnail: hurricaneSliderImage2,
    },
    {
      original: hurricaneSliderImage3,
      thumbnail: hurricaneSliderImage3,
    },
  ];
  const fosterKinshipImages = [
    {
      original: fosterKinshipMainImage,
      thumbnail: fosterKinshipMainImage,
    },
    {
      original: forstKinshipSliderImage1,
      thumbnail: forstKinshipSliderImage1,
    },
    {
      original: forstKinshipSliderImage3,
      thumbnail: forstKinshipSliderImage3,
    },
    {
      original: forstKinshipSliderImage4,
      thumbnail: forstKinshipSliderImage4,
    },
  ];
  const flagsForFreedomImages = [
    {
      original: flagsForFreedomMainImage,
      thumbnail: flagsForFreedomMainImage,
    },
    {
      original: flagsForFreedomSliderImage1,
      thumbnail: flagsForFreedomSliderImage1,
    },
    {
      original: flagsForFreedomSliderImage3,
      thumbnail: flagsForFreedomSliderImage3,
    },
    {
      original: flagsForFreedomSliderImage4,
      thumbnail: flagsForFreedomSliderImage4,
    },
  ];

  const renderLeftNav = (onClick, disabled) => {
    return (
      <a className={classes.leftNav} onClick={onClick} disabled={disabled}>
        <img src={sildele} width="27" />
      </a>
    );
  };

  const renderRightNav = (onClick, disabled) => {
    return (
      <a className={classes.rightNav} onClick={onClick} disabled={disabled}>
        <img src={slidert} width="27" />
      </a>
    );
  };

  const routeChange = (id) => {
    // let path = `donate` + id;
    history.push("/donate/" + id);
  };

  const loadCauses = () => {
    setIsLoading(true);
    const id = props.id;
    callGetApiWithAuth(
      "causes/" + id,
      onSuccessGetCausesData,
      onFailGetCausesData
    );
  };
  const onSuccessGetCausesData = (data) => {
    setCauseData(data.data);
    setIsLoading(false);
  };
  const onFailGetCausesData = (data) => {
    setIsLoading(false);
  };

  useEffect(() => {
    loadCauses();
  }, [props.id]);
  return (
    <Card className={classes.causeDetails}>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          className={`${classes.imageG} img-gallery-s`}
        >
          <ImageGallery
            items={
              props.selectedCause?.id == 2
                ? feedingImages
                : props.selectedCause?.id == 1
                ? fightingImages
                : props.selectedCause?.id == 3
                ? supportingImages
                : props.selectedCause?.id == 39
                ? hurricaneImages
                : props.selectedCause?.id == 41
                ? fosterKinshipImages
                : props.selectedCause?.id == 42
                ? flagsForFreedomImages
                : environmentImages
            }
            showFullscreenButton={false}
            showPlayButton={false}
            renderLeftNav={renderLeftNav}
            renderRightNav={renderRightNav}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <div className={classes.detailContentContainer}>
            <div className={classes.detailHeading}>
              {props.selectedCause?.title}
            </div>
            <p className={classes.detailBody} dangerouslySetInnerHTML={{ __html: props.selectedCause?.description }} />
            <Grid container>
              <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
                <div className={classes.numbers}>{causeData?.donors}</div>
                <div className={classes.names}>Donors</div>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={5} xl={5}>
                <div className={classes.numbers}>
                  {asPrice(causeData?.donatedAmount)}
                </div>
                <div className={classes.names}>Donated</div>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={3} xl={3}>
                <div className={classes.numbers}>{causeData?.partners}</div>
                <div className={classes.names}>Partners</div>
              </Grid>
            </Grid>
            <Button
              className={classes.websiteButton}
              variant="contained"
              onClick={() => routeChange(props.selectedCause?.id)}
            >
              DONATE NOW
            </Button>
          </div>
        </Grid>
      </Grid>
    </Card>
  );
}

const useStyles = makeStyles((theme) => ({
  imageG: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .image-gallery": {
      width: "100% !important",
    },
    "& .image-gallery-image": {
      width: "100% !important",
      height: "331px",
      ObjectFit: "cover !important",
    },
    "& .image-gallery-slide": {
      "& img": {
        ObjectFit: "cover !important",
      },
    },
  },
  container: {
    position: "relative",
    minHeight: 400,
    fontFamily: "Poppins, Nova !important",
  },
  causeDetails: {
    "& .MuiCardContent-root": {
      padding: "60px 70px 50px",
      "@media (max-width: 1300px)": {
        padding: "60px 24px 50px",
      },
      "@media (max-width: 600px)": {
        padding: 0,
      },
    },
    "& .image-gallery-thumbnail": {
      width: "175px",
      border: "1px solid transparent",
    },
    "& .image-gallery-thumbnails": {
      padding: "3px 0",
    },

    "& .image-gallery-thumbnail-image": {
      height: 100,
      objectFit: 'cover',
    },
  },
  detailContentContainer: {
    padding: "20px 22px 20px 26px",

    "@media (max-width: 600px)": {
      padding: 20,
    },
  },
  detailHeading: {
    fontWeight: "bold",
    fontSize: 24,
    color: "#000000",
    fontFamily: "Poppins, Nova !important",
    lineHeight: "28px",
  },
  detailBody: {
    fontSize: 14,
    color: "#6C757D",
    paddingBottom: 30,
    borderBottom: "1px solid #E2E2E2",
    fontFamily: "Poppins, Nova !important",
    lineHeight: "20px",
  },
  numbers: {
    fontWeight: "bold",
    fontSize: 24,
    color: "#3AC7FF",
    fontFamily: "Poppins, Nova !important",
  },
  names: {
    fontSize: 16,
    color: "#6C757D",
    fontFamily: "Poppins, Nova !important",
  },
  websiteButton: {
    marginTop: 20,
    fontSize: 12,
    fontWeight: 600,
    backgroundColor: `${theme.palette.primary.primaryButton} !important`,
    color: `${theme.palette.primary.primaryButtonLabel} !important`,
    fontFamily: "Poppins, Nova !important",
    width: "136px",
  },
  leftNav: {
    position: "absolute",
    zIndex: 9,
    top: "50%",
    cursor: "pointer",
  },
  rightNav: {
    position: "absolute",
    zIndex: 9,
    top: "50%",
    right: 0,
    cursor: "pointer",
  },
}));
